/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
import TwoFactorScaBaseComponent from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/sca/base';
export default class TwoFactorScaBaseModalComponent extends TwoFactorScaBaseComponent {
  /*
   * Overrides
   */
  handleUnknownInitError() {
    super.handleUnknownInitError();
    this.args.close();
  }
}